import clsx, { ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export default twMerge;

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
